import { 
    applyMiddleware, 
    combineReducers,
    createStore, 
    Store 
} from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import { errorMiddleware } from '../middleware/error-middleware';
import { fetchMiddleware } from '../middleware/fetch-middleware';
import { signalRMiddleware } from '../middleware/signalr-middleware';
import { reducers } from '../reducers/root-reducer';
import { rootSaga } from '../sagas/root-saga';
import { GlobalConstants } from '../utils/app-constants';
import { IApplicationState } from './IApplicationState';
import { loadState, saveState, withNumberedPermissions } from './persist-store';

let applicationStore : Store<IApplicationState>;

export function configureStore() {

    // Our Initial App State Shape
    const previousUserData = loadState();
    const initialState = {} as IApplicationState;
    if (previousUserData) {

        if (previousUserData.userdata.cacheVersion === GlobalConstants.CACHE_VERSION) {
            initialState.userdata = withNumberedPermissions(previousUserData.userdata);
        }
    }

    // Make the Saga Middleware
    const sagaMiddleware = createSagaMiddleware({
        onError: (e: Error) => { console.error(e); }
    });

    // Combine all reducers and instantiate the app-wide store instance
    const allReducers = buildRootReducer(reducers);
    
    applicationStore = createStore(
        allReducers,
        initialState,
        composeWithDevTools(
            applyMiddleware(sagaMiddleware, fetchMiddleware, errorMiddleware, signalRMiddleware)
        )
    ) as Store<IApplicationState>;

    applicationStore.subscribe(() => {
        saveState(applicationStore.getState());
    });

    // Run the Sagas
    sagaMiddleware.run(rootSaga);

}

/**
 * Iterate over reducers and combine them
 * @param allReducers A collection of reducers the app uses
 */
function buildRootReducer(allReducers: any) {
    const reducerBundle = Object.assign({}, allReducers);    
    return combineReducers<IApplicationState>(reducerBundle);
}

/**
 * Get a reference to the redux store for use outside components
 */
const getApplicationStore = () => {
    return applicationStore;
};

export { getApplicationStore };
